import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './WindowFooter.module.scss';

export const WindowFooter = ({ children, justify = 'between' }: Props) => (
    <div className={classNames(styles.container, styles[justify])}>
        {children}
    </div>
);

type Props = {
    children: ReactNode;
    justify?: 'start' | 'between' | 'end';
};